export default "__VITE_ASSET__BaUwyL4V__"